import {
  privatePostApi,
  privateGetApi,
  privatePutApi,
  privateDeleteApi,
  getBaseUrl,
} from "../../utils/apiHelper";
import {
  forms,
  currentForm,
  submissions,
  analytics,
} from "../slices/formsSlice";

export const listForms = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/forms", payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(forms(response.data.result));
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};

export const readForm = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/forms/" + id, {})
      .then((response) => {
        if (response.status === 200) {
          dispatch(currentForm(response.data.result));
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const createForm = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/forms", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const updateForm = (payload, id) => () => {
  return new Promise((resolve, reject) => {
    privatePutApi("/forms/" + id, payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const deleteForm = (id) => () => {
  return new Promise((resolve, reject) => {
    privateDeleteApi("/forms/" + id)
      .then((response) => {
        if (response.status === 200) {
          resolve();
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const listSubmissions = (formId, payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/forms/" + formId + "/submissions", payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(submissions(response.data.result));
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const promoteSubmissions = (formId, submissionIds) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/forms/" + formId + "/submissions/promote", {
      submissionIds,
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const rejectSubmissions = (formId, submissionIds, status) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/forms/" + formId + "/submissions/reject", {
      submissionIds,
      status,
    })
      .then((response) => {
        if (response.status === 200) {
          resolve();
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const testFormNotification = (formId, payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/forms/" + formId + "/test", payload || {})
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(response.data?.message || "Test notification failed");
        }
      })
      .catch(reject);
  });
};

// PRD item 3 (FR-3.7), task 3.8. Per-form DPDP notice builder.
export const updateDpdpNotice = (formId, payload) => () => {
  return new Promise((resolve, reject) => {
    privatePutApi("/forms/" + formId + "/dpdp-notice", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};

export const publishDpdpNotice = (formId) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/forms/" + formId + "/dpdp-notice/publish", {})
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch(reject);
  });
};

// PRD item 4 (FR-4.1/FR-4.5/FR-4.6), task 4.6. gate/tiers/routing all live
// under form.settings.gate, updated via the same partial-update route.
export const updateFormGate = (formId, payload) => () => {
  return new Promise((resolve, reject) => {
    privatePutApi("/forms/" + formId + "/gate", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.data?.message);
        }
      })
      .catch(reject);
  });
};

// PRD item 4 (FR-4.8), task 4.5's backend counterpart.
export const restoreSubmission = (formId, subId) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi(
      "/forms/" + formId + "/submissions/" + subId + "/restore",
      {},
    )
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.data?.message);
        }
      })
      .catch(reject);
  });
};

export const retierSubmission = (formId, subId, tier) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/forms/" + formId + "/submissions/" + subId + "/retier", {
      tier,
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.data?.message);
        }
      })
      .catch(reject);
  });
};

export const fetchFormAnalytics = (formId) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/forms/" + formId + "/analytics", {})
      .then((response) => {
        if (response.status === 200) {
          dispatch(analytics(response.data.result));
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch(reject);
  });
};

export const getPublicFormActionUrl = (publicId) => {
  const base = getBaseUrl();
  return `${base}/f/${publicId}`;
};

export const getPublicFormTokenUrl = (publicId) => {
  return `${getPublicFormActionUrl(publicId)}/token`;
};

// FR-3.7: the standalone DPDP notice page (GET /f/:publicId/notice,
// mailinflow-apis routes/f/index.js), server-rendered HTML, not a React
// route -- linked from the hosted form, not embedded in it.
export const getPublicFormNoticeUrl = (publicId) => {
  return `${getPublicFormActionUrl(publicId)}/notice`;
};

export const getHostedFormUrl = (publicId) => {
  if (typeof window === "undefined") return `/f/${publicId}`;
  return `${window.location.origin}/f/${publicId}`;
};

export const getPublicFormConfigUrl = (publicId) => {
  return `/f/${publicId}`;
};

export const exportSubmissionsUrl = (formId, format) => {
  const base = getBaseUrl();
  const token = localStorage.getItem("accessToken");
  return `${base}/forms/${formId}/submissions/export?format=${format}&accessToken=${token}`;
};
